import { A11yModule } from '@angular/cdk/a11y';
import { CdkConnectedOverlay, CdkOverlayOrigin, OverlayModule } from '@angular/cdk/overlay';
import { DatePipe } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    CUSTOM_ELEMENTS_SCHEMA,
    input,
    output,
    signal
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Application, ApplicationStatusEnum } from '@tran-monorepo/interfaces/applications';
import { calculateApplicationProgress } from '../../../utils/application-progress.utils';
import { ApplicationRequestersComponent } from '../application-requesters/application-requesters.component';
import { ApplicationStatusIndicatorComponent } from '../application-status-indicator/application-status-indicator.component';
import { applicationTileMenuOverlayPositions } from './application-tile.config';
import { ApplicationTileAction } from './application-tile.model';

@Component({
    selector: 'tran-application-tile',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ApplicationStatusIndicatorComponent,
        ApplicationRequestersComponent,
        DatePipe,
        TranslatePipe,
        CdkOverlayOrigin,
        CdkConnectedOverlay,
        OverlayModule,
        A11yModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './application-tile.component.html'
})
export class ApplicationTileComponent {
    public readonly application = input.required<Application>();
    public readonly actions = input<ApplicationTileAction[]>([]);
    /** Pre-computed progress (0–100). When omitted, calculated from `application` alone (no files check). */
    public readonly progress = input<number>();
    public readonly actionClicked = output<{ action: ApplicationTileAction; application: Application }>();

    protected isMenuOpen = signal(false);

    protected readonly resolvedProgress = computed(
        () => this.progress() ?? calculateApplicationProgress(this.application())
    );

    protected readonly overlayPositions = applicationTileMenuOverlayPositions;
    protected readonly ApplicationStatus = ApplicationStatusEnum;

    protected readonly visibleActions = computed(() => {
        const app = this.application();
        return this.actions().filter(action => (app ? (action.condition?.(app) ?? true) : false));
    });

    protected onActionClick(action: ApplicationTileAction): void {
        const app = this.application();
        if (app) {
            this.actionClicked.emit({ action, application: app });
            this.isMenuOpen.set(false);
        }
    }
}
